import { render, staticRenderFns } from "./Card-Action.vue?vue&type=template&id=5077befc&scoped=true&"
import script from "./Card-Action.vue?vue&type=script&lang=js&"
export * from "./Card-Action.vue?vue&type=script&lang=js&"
import style0 from "./Card-Action.vue?vue&type=style&index=0&id=5077befc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077befc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VSpacer})
